<template>
	<div class="indexView">
		<el-container>
			<el-main>
				<HeaderRow selUrl="free"></HeaderRow>
				<div class="banner" v-if="navList[3]&&navList[3].icon_image">
					<el-image style="width: 100%; height: 300px" fit="cover" :src="navList[3].icon_image"></el-image>
				</div>
				<div class="breadcrumb">
					<div class="backItem" @click="()=>$router.back()"><i class="el-icon-arrow-left">返回</i></div>
					<el-breadcrumb separator="/">
						<el-breadcrumb-item to="/">首页</el-breadcrumb-item>
						<el-breadcrumb-item to="/free">免费小课</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
				<!-- <div class="search">
					<el-input placeholder="当前条件下搜索" v-model="inputStr">
						<el-button slot="append" icon="el-icon-search"></el-button>
					</el-input>
				</div> -->
				<div class="courseDiv" v-if="freeList.length">
					<div class="courseItem" v-for="(item, index) in freeList" :key="`${index}`" @click="gotoDetail(item)">
						<img v-if="item.image" :src="item.image" />
						<img v-else :src="require(`@/assets/home/img_mf/ke${index%8+1}.jpg`)" />
						<p>{{item.name}}</p>
						<p>共{{item.course_num}}课</p>
						<p v-if="item.price*100 === 0"><span></span><span>免费</span></p>
						<p v-else><span>￥</span><span>{{Price(item.price,2)[0]}}</span><span>.{{Price(item.price,2)[1]}}</span></p>
					</div>
				</div>
				<el-empty v-else description="暂无数据" :image-size="72"></el-empty>
				<!-- <div class="pagination">
					<el-pagination background layout="prev, pager, next" :total="1000">
					</el-pagination>
				</div> -->
				<FooterRow></FooterRow>
			</el-main>
		</el-container>
	</div>
</template>

<script>
	import indexjs from "./index.js";
	import {
		copy
	} from "clipboard";
	import HeaderRow from "@/components/headerRow.vue";
	import FooterRow from "@/components/footerRow.vue";

	export default {
		methods: {
			copy,
		},
		...indexjs,
		components: {
			HeaderRow,
			FooterRow,
		},
		computed: {},

	};
</script>

<style lang="scss" scoped>
	@import "./index.scss";
</style>